export default {"src":"/_next/static/media/cart.fa54374e.svg","height":21,"width":25,"blurWidth":0,"blurHeight":0};